import { vueRoutes } from '@/vue-router/routes'

export default class PermissionService {
  getRoutePermissionsByName (name) {
    const found = vueRoutes[name].permissions
    return found ? found[0] : null
  }

  isChildrenForbidden (pageName, resourceName, actionName, accountPermissions) {
    if (accountPermissions.length === 1 &&
      accountPermissions[0].action === '*' &&
      accountPermissions[0].resource === '*') {
      return false // super admin
    }

    const routePermissions = this.getRoutePermissionsByName(pageName)
    if (!routePermissions) {
      return true
    }

    if (!routePermissions.children) {
      return true
    }
    if (routePermissions.children.length === 0) {
      return true
    }
    const routePermission = routePermissions.children.find(r => {
      return r.action === actionName && r.resource === resourceName
    })

    const found = accountPermissions.find(ap => {
      return routePermission &&
        ap.action === routePermission.action &&
        ap.resource === routePermission.resource
    })

    return !found
  }
}
